import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from './pager.module.css';
function uuid() {
    try {
        return crypto.randomUUID();
    }
    catch (error) {
        return Math.random().toString();
    }
}
export function Pager(_a) {
    var _b, _c, _d;
    var activePageNumber = _a.activePageNumber, pageCount = _a.pageCount, isLoading = _a.isLoading, onPageChange = _a.onPageChange;
    var _e = useState([]), pageNumbers = _e[0], setPageNumbers = _e[1];
    var _f = useState([]), pageItems = _f[0], setPageItems = _f[1];
    useEffect(function () {
        if (pageCount === 0)
            return;
        generatePageNumbers();
    }, [pageCount]);
    useEffect(function () {
        generatePageItems();
    }, [pageNumbers, activePageNumber]);
    function generatePageNumbers() {
        var tempPageNumbers = [];
        var pageNumber = 1;
        while (pageNumber <= pageCount) {
            tempPageNumbers.push(pageNumber);
            pageNumber++;
        }
        setPageNumbers(tempPageNumbers);
    }
    function generatePageItems() {
        if (pageNumbers.length === 0)
            return setPageItems([]);
        if (pageNumbers.length <= 5)
            return setPageItems(pageNumbers);
        var tempActivePageNumbers = [];
        if (activePageNumber <= 2) {
            tempActivePageNumbers = ['placeholder', 'placeholder', 1, 2, 3, 'dots', pageCount];
            setPageItems(tempActivePageNumbers);
            return;
        }
        if (activePageNumber >= pageCount - 1) {
            tempActivePageNumbers = [1, 'dots', pageCount - 2, pageCount - 1, pageCount, 'placeholder', 'placeholder'];
            setPageItems(tempActivePageNumbers);
            return;
        }
        tempActivePageNumbers = [1, 'dots', activePageNumber - 1, activePageNumber, activePageNumber + 1, 'dots', pageCount];
        setPageItems(tempActivePageNumbers);
    }
    function onClickPreviousHandler() {
        if (activePageNumber === 0)
            return;
        if (!!onPageChange)
            onPageChange(activePageNumber - 1);
    }
    function onClickPageItemHandler(pageItem) {
        if (typeof pageItem !== 'number')
            return;
        if (!!onPageChange)
            onPageChange(pageItem);
    }
    function onClickNextHandler() {
        if (activePageNumber === pageCount)
            return;
        if (!!onPageChange)
            onPageChange(activePageNumber + 1);
    }
    return (React.createElement("nav", { className: classNames(styles.pagerWrapper, (_b = {}, _b[styles.disabled] = isLoading, _b), "kplr_pagerWrapper") },
        React.createElement("div", { className: classNames(styles.previousButton, (_c = {}, _c[styles.disabled] = activePageNumber - 1 === 0, _c)), onClick: onClickPreviousHandler }, "PREV"),
        pageItems.map(function (pageItem) {
            var _a;
            var key = typeof pageItem === 'number' ? "navigation_".concat(pageItem) : uuid();
            return (React.createElement("div", { key: key, id: key, className: classNames(styles.pageItem, (_a = {}, _a[styles.active] = pageItem === activePageNumber, _a[styles.dots] = pageItem === 'dots', _a[styles.placeholder] = pageItem === 'placeholder', _a)), onClick: function () { return onClickPageItemHandler(pageItem); } }, pageItem === 'dots' ? '...' : pageItem === 'placeholder' ? '' : pageItem));
        }),
        React.createElement("div", { className: classNames(styles.previousButton, styles.nextButton, (_d = {}, _d[styles.disabled] = activePageNumber === pageCount, _d)), onClick: onClickNextHandler }, "NEXT")));
}
export default Pager;
